// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__zjkJL","signatureButtonsRight":"ModalSign_signatureButtonsRight__3wsMt"};